import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { isSameMonth } from 'date-fns';
import { MobileDatePickerProps } from './MobileDatePicker';
import { mobileMonthPickerStyles } from './MobileMonthPicker.styles';

const MobileMonthPicker = (props: MobileDatePickerProps) => {
  const { startDate, endDate, selectedDay, setActiveDate, closeCalendarModal } = props;

  const currentDate = selectedDay || new Date();

  // Generate years range based on min/max dates
  const minYear = startDate ? startDate.getFullYear() : currentDate.getFullYear() - 2;
  const maxYear = endDate ? endDate.getFullYear() : currentDate.getFullYear() + 2;

  const years = [];
  for (let year = minYear; year <= maxYear; year++) {
    years.push(new Date(year, 0, 1));
  }

  const months = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUN',
    'JUL',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC',
  ];

  const onMonthClick = (year: number, monthIndex: number) => {
    const newDate = new Date(year, monthIndex, 1);
    setActiveDate?.(newDate);
    closeCalendarModal?.();
  };

  const isMonthSelected = (year: number, monthIndex: number) => {
    const monthDate = new Date(year, monthIndex, 1);
    return isSameMonth(monthDate, currentDate);
  };

  const isMonthDisabled = (year: number, monthIndex: number) => {
    const monthDate = new Date(year, monthIndex, 1);
    const monthStart = new Date(year, monthIndex, 1);
    const monthEnd = new Date(year, monthIndex + 1, 0);

    if (startDate && monthEnd < startDate) return true;
    if (endDate && monthStart > endDate) return true;
    return false;
  };

  return (
    <Box sx={mobileMonthPickerStyles.wrapper} data-id={'OuterWrapper'}>
      {years.map(yearDate => {
        const year = yearDate.getFullYear();
        return (
          <Box key={year} sx={mobileMonthPickerStyles.yearContainer}>
            <Typography sx={mobileMonthPickerStyles.yearHeader}>{year}</Typography>
            <Box sx={mobileMonthPickerStyles.monthsGrid}>
              {months.map((monthName, monthIndex) => {
                const isSelected = isMonthSelected(year, monthIndex);
                const isDisabled = isMonthDisabled(year, monthIndex);

                return (
                  <Box key={monthIndex} sx={mobileMonthPickerStyles.monthGridItem}>
                    <Button
                      variant="text"
                      disabled={isDisabled}
                      onClick={() => onMonthClick(year, monthIndex)}
                      sx={
                        isSelected
                          ? mobileMonthPickerStyles.selectedMonthButton
                          : mobileMonthPickerStyles.monthButton
                      }
                      fullWidth>
                      {monthName}
                    </Button>
                  </Box>
                );
              })}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default MobileMonthPicker;
